import { Injectable, inject } from '@angular/core';
import { Project, ProjectsCollection } from '@dges/modules/portfolio/domain';
import { Observable } from 'rxjs';
import {
  Firestore,
  CollectionReference,
  DocumentReference,
  collection,
  collectionData,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class ProjectsCollectionService implements ProjectsCollection {
  private firestore = inject(Firestore);

  private projectsCollection = collection(
    this.firestore,
    'projects',
  ) as CollectionReference<Project>;

  public getProjects(): Observable<Project[]> {
    return collectionData(this.projectsCollection, {
      idField: 'id',
    }) as Observable<Project[]>;
  }

  public addProject(project: Project): Promise<DocumentReference<Project>> {
    return addDoc(this.projectsCollection, project);
  }

  public editProject(project: Project): Promise<void> {
    return updateDoc(doc(this.projectsCollection, project.id), { ...project });
  }

  public deleteProject(project: Project): Promise<void> {
    return deleteDoc(doc(this.projectsCollection, project.id));
  }
}
